import styled from 'styled-components'
import { IGeoMapProps } from './types'

export const ChartContainer = styled.div<IGeoMapProps>`
  width: 90%;
  height: ${({ height }) => height || '100%'};
  padding: 0 50px;
`
